import __ from "standard/dunder";
import * as f from "standard/f";

function formData(_target, _propertyKey, descriptor) {
  const next = descriptor.value;

  Object.assign(descriptor, {
    value(event) {
      if (f.not(event instanceof Event)) {
        return Reflect.apply(next, this, [event]);
      }

      const elements = this.shadowRoot.querySelectorAll("*");
      const data = Object.fromEntries(
        Array.from(elements)
          .filter(
            (element) =>
              f.equals(element.type, __.control__) ||
              element.tagName.toLowerCase() === "select",
          )
          .map(({ name, value }) => [name, value]),
      );

      return Reflect.apply(next, this, [data]);
    },
  });
}

export default formData;
